export const formatImp = (number) => number ? new Intl.NumberFormat().format(number) : 0;
export const formatRevenue = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
});
export const momentFormat = "YYYY-MM-DD";